import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=068a1e6e&scoped=true&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"
import style1 from "./Pagination.vue?vue&type=style&index=1&id=068a1e6e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068a1e6e",
  null
  
)

export default component.exports